import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService, NavigationService } from '@core/services';

export const accountRoutesGuard: CanActivateFn = () => {
  const navigationService = inject(NavigationService);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }
  navigationService.navigateToLogin();
  return false;
};
